import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/electricien-offerte/opvragen")({
  beforeLoad: () => { throw redirect({ to: "/offerte-aanvragen", replace: true }); },
  head: () => ({ meta: [
    { title: "Elektricien offerte aanvragen | Elvion Group Nederland" },
    { name: "description", content: "Vraag passende offertes aan voor jouw elektricienproject bij Elvion Group Nederland." },
    { property: "og:title", content: "Elektricien offerte aanvragen | Elvion Group Nederland" },
    { property: "og:description", content: "Een vrijblijvende offerte voor jouw installatieproject." },
    { property: "og:type", content: "website" }, { name: "twitter:card", content: "summary_large_image" },
  ] }),
});
